import Z, { createContext as le, useEffect as Jt, useLayoutEffect as fe, useContext as de, useRef as b, useMemo as pe, useCallback as K, useDebugValue as Ee, useState as vt } from "react";
import { useI18n as Se } from "next-localization";
import { f as he } from "./fetcher.CPHInLJD.js";
var ct = { exports: {} }, St = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qt;
function me() {
  if (qt) return St;
  qt = 1;
  var t = Z;
  function e(l, E) {
    return l === E && (l !== 0 || 1 / l === 1 / E) || l !== l && E !== E;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, s = t.useLayoutEffect, o = t.useDebugValue;
  function u(l, E) {
    var c = E(), h = r({ inst: { value: c, getSnapshot: E } }), d = h[0].inst, y = h[1];
    return s(
      function() {
        d.value = c, d.getSnapshot = E, p(d) && y({ inst: d });
      },
      [l, c, E]
    ), i(
      function() {
        return p(d) && y({ inst: d }), l(function() {
          p(d) && y({ inst: d });
        });
      },
      [l]
    ), o(c), c;
  }
  function p(l) {
    var E = l.getSnapshot;
    l = l.value;
    try {
      var c = E();
      return !n(l, c);
    } catch {
      return !0;
    }
  }
  function O(l, E) {
    return E();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? O : u;
  return St.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : f, St;
}
var ht = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ht;
function ge() {
  return Ht || (Ht = 1, process.env.NODE_ENV !== "production" && function() {
    function t(c, h) {
      return c === h && (c !== 0 || 1 / c === 1 / h) || c !== c && h !== h;
    }
    function e(c, h) {
      f || i.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var d = h();
      if (!l) {
        var y = h();
        s(d, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), l = !0);
      }
      y = o({
        inst: { value: d, getSnapshot: h }
      });
      var a = y[0].inst, v = y[1];
      return p(
        function() {
          a.value = d, a.getSnapshot = h, n(a) && v({ inst: a });
        },
        [c, d, h]
      ), u(
        function() {
          return n(a) && v({ inst: a }), c(function() {
            n(a) && v({ inst: a });
          });
        },
        [c]
      ), O(d), d;
    }
    function n(c) {
      var h = c.getSnapshot;
      c = c.value;
      try {
        var d = h();
        return !s(c, d);
      } catch {
        return !0;
      }
    }
    function r(c, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = Z, s = typeof Object.is == "function" ? Object.is : t, o = i.useState, u = i.useEffect, p = i.useLayoutEffect, O = i.useDebugValue, f = !1, l = !1, E = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    ht.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : E, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ht;
}
var $t;
function Oe() {
  return $t || ($t = 1, process.env.NODE_ENV === "production" ? ct.exports = me() : ct.exports = ge()), ct.exports;
}
var _e = Oe();
const Yt = 0, Xt = 1, Qt = 2, Gt = 3;
var Kt = Object.prototype.hasOwnProperty;
function Rt(t, e) {
  var n, r;
  if (t === e) return !0;
  if (t && e && (n = t.constructor) === e.constructor) {
    if (n === Date) return t.getTime() === e.getTime();
    if (n === RegExp) return t.toString() === e.toString();
    if (n === Array) {
      if ((r = t.length) === e.length)
        for (; r-- && Rt(t[r], e[r]); ) ;
      return r === -1;
    }
    if (!n || typeof t == "object") {
      r = 0;
      for (n in t)
        if (Kt.call(t, n) && ++r && !Kt.call(e, n) || !(n in e) || !Rt(t[n], e[n])) return !1;
      return Object.keys(e).length === r;
    }
  }
  return t !== t && e !== e;
}
const q = /* @__PURE__ */ new WeakMap(), H = () => {
}, R = (
  /*#__NOINLINE__*/
  H()
), yt = Object, S = (t) => t === R, j = (t) => typeof t == "function", M = (t, e) => ({
  ...t,
  ...e
}), Zt = (t) => j(t.then), mt = {}, ut = {}, It = "undefined", st = typeof window != It, Tt = typeof document != It, we = st && "Deno" in window, ve = () => st && typeof window.requestAnimationFrame != It, te = (t, e) => {
  const n = q.get(t);
  return [
    // Getter
    () => !S(e) && t.get(e) || mt,
    // Setter
    (r) => {
      if (!S(e)) {
        const i = t.get(e);
        e in ut || (ut[e] = i), n[5](e, M(i, r), i || mt);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !S(e) && e in ut ? ut[e] : !S(e) && t.get(e) || mt
  ];
};
let Dt = !0;
const Re = () => Dt, [Ct, Lt] = st && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  H,
  H
], ye = () => {
  const t = Tt && document.visibilityState;
  return S(t) || t !== "hidden";
}, Te = (t) => (Tt && document.addEventListener("visibilitychange", t), Ct("focus", t), () => {
  Tt && document.removeEventListener("visibilitychange", t), Lt("focus", t);
}), De = (t) => {
  const e = () => {
    Dt = !0, t();
  }, n = () => {
    Dt = !1;
  };
  return Ct("online", e), Ct("offline", n), () => {
    Lt("online", e), Lt("offline", n);
  };
}, Ce = {
  isOnline: Re,
  isVisible: ye
}, Le = {
  initFocus: Te,
  initReconnect: De
}, At = !Z.useId, nt = !st || we, Ae = (t) => ve() ? window.requestAnimationFrame(t) : setTimeout(t, 1), et = nt ? Jt : fe, gt = typeof navigator < "u" && navigator.connection, kt = !nt && gt && ([
  "slow-2g",
  "2g"
].includes(gt.effectiveType) || gt.saveData), lt = /* @__PURE__ */ new WeakMap(), Ot = (t, e) => yt.prototype.toString.call(t) === `[object ${e}]`;
let be = 0;
const bt = (t) => {
  const e = typeof t, n = Ot(t, "Date"), r = Ot(t, "RegExp"), i = Ot(t, "Object");
  let s, o;
  if (yt(t) === t && !n && !r) {
    if (s = lt.get(t), s) return s;
    if (s = ++be + "~", lt.set(t, s), Array.isArray(t)) {
      for (s = "@", o = 0; o < t.length; o++)
        s += bt(t[o]) + ",";
      lt.set(t, s);
    }
    if (i) {
      s = "#";
      const u = yt.keys(t).sort();
      for (; !S(o = u.pop()); )
        S(t[o]) || (s += o + ":" + bt(t[o]) + ",");
      lt.set(t, s);
    }
  } else
    s = n ? t.toJSON() : e == "symbol" ? t.toString() : e == "string" ? JSON.stringify(t) : "" + t;
  return s;
}, ft = (t) => {
  if (j(t))
    try {
      t = t();
    } catch {
      t = "";
    }
  const e = t;
  return t = typeof t == "string" ? t : (Array.isArray(t) ? t.length : t) ? bt(t) : "", [
    t,
    e
  ];
};
let Ie = 0;
const rt = () => ++Ie;
async function ee(...t) {
  const [e, n, r, i] = t, s = M({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let o = s.populateCache;
  const u = s.rollbackOnError;
  let p = s.optimisticData;
  const O = (E) => typeof u == "function" ? u(E) : u !== !1, f = s.throwOnError;
  if (j(n)) {
    const E = n, c = [], h = e.keys();
    for (const d of h)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(d) && E(e.get(d)._k) && c.push(d);
    return Promise.all(c.map(l));
  }
  return l(n);
  async function l(E) {
    const [c] = ft(E);
    if (!c) return;
    const [h, d] = te(e, c), [y, a, v, P] = q.get(e), D = () => {
      const x = y[c];
      return (j(s.revalidate) ? s.revalidate(h().data, E) : s.revalidate !== !1) && (delete v[c], delete P[c], x && x[0]) ? x[0](Qt).then(() => h().data) : h().data;
    };
    if (t.length < 3)
      return D();
    let C = r, I;
    const k = rt();
    a[c] = [
      k,
      0
    ];
    const _ = !S(p), B = h(), F = B.data, z = B._c, $ = S(z) ? F : z;
    if (_ && (p = j(p) ? p($, F) : p, d({
      data: p,
      _c: $
    })), j(C))
      try {
        C = C($);
      } catch (x) {
        I = x;
      }
    if (C && Zt(C))
      if (C = await C.catch((x) => {
        I = x;
      }), k !== a[c][0]) {
        if (I) throw I;
        return C;
      } else I && _ && O(I) && (o = !0, d({
        data: $,
        _c: R
      }));
    if (o && !I)
      if (j(o)) {
        const x = o(C, $);
        d({
          data: x,
          error: R,
          _c: R
        });
      } else
        d({
          data: C,
          error: R,
          _c: R
        });
    if (a[c][1] = rt(), Promise.resolve(D()).then(() => {
      d({
        _c: R
      });
    }), I) {
      if (f) throw I;
      return;
    }
    return C;
  }
}
const Bt = (t, e) => {
  for (const n in t)
    t[n][0] && t[n][0](e);
}, Ve = (t, e) => {
  if (!q.has(t)) {
    const n = M(Le, e), r = /* @__PURE__ */ Object.create(null), i = ee.bind(R, t);
    let s = H;
    const o = /* @__PURE__ */ Object.create(null), u = (f, l) => {
      const E = o[f] || [];
      return o[f] = E, E.push(l), () => E.splice(E.indexOf(l), 1);
    }, p = (f, l, E) => {
      t.set(f, l);
      const c = o[f];
      if (c)
        for (const h of c)
          h(l, E);
    }, O = () => {
      if (!q.has(t) && (q.set(t, [
        r,
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        i,
        p,
        u
      ]), !nt)) {
        const f = n.initFocus(setTimeout.bind(R, Bt.bind(R, r, Yt))), l = n.initReconnect(setTimeout.bind(R, Bt.bind(R, r, Xt)));
        s = () => {
          f && f(), l && l(), q.delete(t);
        };
      }
    };
    return O(), [
      t,
      i,
      O,
      s
    ];
  }
  return [
    t,
    q.get(t)[4]
  ];
}, xe = (t, e, n, r, i) => {
  const s = n.errorRetryCount, o = i.retryCount, u = ~~((Math.random() + 0.5) * (1 << (o < 8 ? o : 8))) * n.errorRetryInterval;
  !S(s) && o > s || setTimeout(r, u, i);
}, Ne = Rt, [ne, Me] = Ve(/* @__PURE__ */ new Map()), Fe = M(
  {
    // events
    onLoadingSlow: H,
    onSuccess: H,
    onError: H,
    onErrorRetry: xe,
    onDiscarded: H,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: kt ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: kt ? 5e3 : 3e3,
    // providers
    compare: Ne,
    isPaused: () => !1,
    cache: ne,
    mutate: Me,
    fallback: {}
  },
  // use web preset by default
  Ce
), je = (t, e) => {
  const n = M(t, e);
  if (e) {
    const { use: r, fallback: i } = t, { use: s, fallback: o } = e;
    r && s && (n.use = r.concat(s)), i && o && (n.fallback = M(i, o));
  }
  return n;
}, Pe = le({}), We = "$inf$", re = st && window.__SWR_DEVTOOLS_USE__, Ue = re ? window.__SWR_DEVTOOLS_USE__ : [], qe = () => {
  re && (window.__SWR_DEVTOOLS_REACT__ = Z);
}, se = (t) => j(t[1]) ? [
  t[0],
  t[1],
  t[2] || {}
] : [
  t[0],
  null,
  (t[1] === null ? t[2] : t[1]) || {}
], oe = () => M(Fe, de(Pe)), He = (t) => (e, n, r) => t(e, n && ((...s) => {
  const [o] = ft(e), [, , , u] = q.get(ne);
  if (o.startsWith(We))
    return n(...s);
  const p = u[o];
  return S(p) ? n(...s) : (delete u[o], p);
}), r), $e = Ue.concat(He), Ge = (t) => function(...n) {
  const r = oe(), [i, s, o] = se(n), u = je(r, o);
  let p = t;
  const { use: O } = u, f = (O || []).concat($e);
  for (let l = f.length; l--; )
    p = f[l](p);
  return p(i, s || u.fetcher || null, u);
}, Ke = (t, e, n) => {
  const r = e[t] || (e[t] = []);
  return r.push(n), () => {
    const i = r.indexOf(n);
    i >= 0 && (r[i] = r[r.length - 1], r.pop());
  };
}, ke = (t, e) => (...n) => {
  const [r, i, s] = se(n), o = (s.use || []).concat(e);
  return t(r, i, {
    ...s,
    use: o
  });
};
qe();
const _t = Z.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((t) => {
  switch (t.status) {
    case "pending":
      throw t;
    case "fulfilled":
      return t.value;
    case "rejected":
      throw t.reason;
    default:
      throw t.status = "pending", t.then((e) => {
        t.status = "fulfilled", t.value = e;
      }, (e) => {
        t.status = "rejected", t.reason = e;
      }), t;
  }
}), wt = {
  dedupe: !0
}, Be = (t, e, n) => {
  const { cache: r, compare: i, suspense: s, fallbackData: o, revalidateOnMount: u, revalidateIfStale: p, refreshInterval: O, refreshWhenHidden: f, refreshWhenOffline: l, keepPreviousData: E } = n, [c, h, d, y] = q.get(r), [a, v] = ft(t), P = b(!1), D = b(!1), C = b(a), I = b(e), k = b(n), _ = () => k.current, B = () => _().isVisible() && _().isOnline(), [F, z, $, x] = te(r, a), J = b({}).current, ot = S(o) ? S(n.fallback) ? R : n.fallback[a] : o, Vt = (g, m) => {
    for (const L in J) {
      const w = L;
      if (w === "data") {
        if (!i(g[w], m[w]) && (!S(g[w]) || !i(at, m[w])))
          return !1;
      } else if (m[w] !== g[w])
        return !1;
    }
    return !0;
  }, xt = pe(() => {
    const g = !a || !e ? !1 : S(u) ? _().isPaused() || s ? !1 : p !== !1 : u, m = (A) => {
      const W = M(A);
      return delete W._k, g ? {
        isValidating: !0,
        isLoading: !0,
        ...W
      } : W;
    }, L = F(), w = x(), N = m(L), Q = L === w ? N : m(w);
    let T = N;
    return [
      () => {
        const A = m(F());
        return Vt(A, T) ? (T.data = A.data, T.isLoading = A.isLoading, T.isValidating = A.isValidating, T.error = A.error, T) : (T = A, A);
      },
      () => Q
    ];
  }, [
    r,
    a
  ]), Y = _e.useSyncExternalStore(K(
    (g) => $(a, (m, L) => {
      Vt(L, m) || g();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      a
    ]
  ), xt[0], xt[1]), Nt = !P.current, ie = c[a] && c[a].length > 0, X = Y.data, G = S(X) ? ot && Zt(ot) ? _t(ot) : ot : X, it = Y.error, dt = b(G), at = E ? S(X) ? S(dt.current) ? G : dt.current : X : G, Mt = ie && !S(it) ? !1 : Nt && !S(u) ? u : _().isPaused() ? !1 : s ? S(G) ? !1 : p : S(G) || p, Ft = !!(a && e && Nt && Mt), ae = S(Y.isValidating) ? Ft : Y.isValidating, ce = S(Y.isLoading) ? Ft : Y.isLoading, tt = K(
    async (g) => {
      const m = I.current;
      if (!a || !m || D.current || _().isPaused())
        return !1;
      let L, w, N = !0;
      const Q = g || {}, T = !d[a] || !Q.dedupe, A = () => At ? !D.current && a === C.current && P.current : a === C.current, W = {
        isValidating: !1,
        isLoading: !1
      }, Pt = () => {
        z(W);
      }, Wt = () => {
        const V = d[a];
        V && V[1] === w && delete d[a];
      }, Ut = {
        isValidating: !0
      };
      S(F().data) && (Ut.isLoading = !0);
      try {
        if (T && (z(Ut), n.loadingTimeout && S(F().data) && setTimeout(() => {
          N && A() && _().onLoadingSlow(a, n);
        }, n.loadingTimeout), d[a] = [
          m(v),
          rt()
        ]), [L, w] = d[a], L = await L, T && setTimeout(Wt, n.dedupingInterval), !d[a] || d[a][1] !== w)
          return T && A() && _().onDiscarded(a), !1;
        W.error = R;
        const V = h[a];
        if (!S(V) && // case 1
        (w <= V[0] || // case 2
        w <= V[1] || // case 3
        V[1] === 0))
          return Pt(), T && A() && _().onDiscarded(a), !1;
        const U = F().data;
        W.data = i(U, L) ? U : L, T && A() && _().onSuccess(L, a, n);
      } catch (V) {
        Wt();
        const U = _(), { shouldRetryOnError: pt } = U;
        U.isPaused() || (W.error = V, T && A() && (U.onError(V, a, U), (pt === !0 || j(pt) && pt(V)) && (!_().revalidateOnFocus || !_().revalidateOnReconnect || B()) && U.onErrorRetry(V, a, U, (ue) => {
          const Et = c[a];
          Et && Et[0] && Et[0](Gt, ue);
        }, {
          retryCount: (Q.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return N = !1, Pt(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      a,
      r
    ]
  ), jt = K(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...g) => ee(r, C.current, ...g),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (et(() => {
    I.current = e, k.current = n, S(X) || (dt.current = X);
  }), et(() => {
    if (!a) return;
    const g = tt.bind(R, wt);
    let m = 0;
    _().revalidateOnFocus && (m = Date.now() + _().focusThrottleInterval);
    const w = Ke(a, c, (N, Q = {}) => {
      if (N == Yt) {
        const T = Date.now();
        _().revalidateOnFocus && T > m && B() && (m = T + _().focusThrottleInterval, g());
      } else if (N == Xt)
        _().revalidateOnReconnect && B() && g();
      else {
        if (N == Qt)
          return tt();
        if (N == Gt)
          return tt(Q);
      }
    });
    return D.current = !1, C.current = a, P.current = !0, z({
      _k: v
    }), Mt && (S(G) || nt ? g() : Ae(g)), () => {
      D.current = !0, w();
    };
  }, [
    a
  ]), et(() => {
    let g;
    function m() {
      const w = j(O) ? O(F().data) : O;
      w && g !== -1 && (g = setTimeout(L, w));
    }
    function L() {
      !F().error && (f || _().isVisible()) && (l || _().isOnline()) ? tt(wt).then(m) : m();
    }
    return m(), () => {
      g && (clearTimeout(g), g = -1);
    };
  }, [
    O,
    f,
    l,
    a
  ]), Ee(at), s && S(G) && a) {
    if (!At && nt)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    I.current = e, k.current = n, D.current = !1;
    const g = y[a];
    if (!S(g)) {
      const m = jt(g);
      _t(m);
    }
    if (S(it)) {
      const m = tt(wt);
      S(at) || (m.status = "fulfilled", m.value = !0), _t(m);
    } else
      throw it;
  }
  return {
    mutate: jt,
    get data() {
      return J.data = !0, at;
    },
    get error() {
      return J.error = !0, it;
    },
    get isValidating() {
      return J.isValidating = !0, ae;
    },
    get isLoading() {
      return J.isLoading = !0, ce;
    }
  };
}, ze = Ge(Be), zt = At ? (t) => {
  t();
} : Z.startTransition, Je = (t) => {
  const [, e] = vt({}), n = b(!1), r = b(t), i = b({
    data: !1,
    error: !1,
    isValidating: !1
  }), s = K((o) => {
    let u = !1;
    const p = r.current;
    for (const O in o)
      if (Object.prototype.hasOwnProperty.call(o, O)) {
        const f = O;
        p[f] !== o[f] && (p[f] = o[f], i.current[f] && (u = !0));
      }
    u && !n.current && e({});
  }, []);
  return et(() => (n.current = !1, () => {
    n.current = !0;
  })), [
    r,
    i.current,
    s
  ];
}, Ye = () => (t, e, n = {}) => {
  const { mutate: r } = oe(), i = b(t), s = b(e), o = b(n), u = b(0), [p, O, f] = Je({
    data: R,
    error: R,
    isMutating: !1
  }), l = p.current, E = K(
    async (h, d) => {
      const [y, a] = ft(i.current);
      if (!s.current)
        throw new Error("Can’t trigger the mutation: missing fetcher.");
      if (!y)
        throw new Error("Can’t trigger the mutation: missing key.");
      const v = M(M({
        populateCache: !1,
        throwOnError: !0
      }, o.current), d), P = rt();
      u.current = P, f({
        isMutating: !0
      });
      try {
        const D = await r(
          y,
          s.current(a, {
            arg: h
          }),
          // We must throw the error here so we can catch and update the states.
          M(v, {
            throwOnError: !0
          })
        );
        return u.current <= P && (zt(() => f({
          data: D,
          isMutating: !1,
          error: void 0
        })), v.onSuccess == null || v.onSuccess.call(v, D, y, v)), D;
      } catch (D) {
        if (u.current <= P && (zt(() => f({
          error: D,
          isMutating: !1
        })), v.onError == null || v.onError.call(v, D, y, v), v.throwOnError))
          throw D;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), c = K(() => {
    u.current = rt(), f({
      data: R,
      error: R,
      isMutating: !1
    });
  }, []);
  return et(() => {
    i.current = t, s.current = e, o.current = n;
  }), {
    trigger: E,
    reset: c,
    get data() {
      return O.data = !0, l.data;
    },
    get error() {
      return O.error = !0, l.error;
    },
    get isMutating() {
      return O.isMutating = !0, l.isMutating;
    }
  };
}, Xe = ke(ze, Ye), Qe = (t) => {
  const e = async (o, { arg: u }) => {
    const p = {
      method: u ? "POST" : "GET",
      headers: {
        "Content-Type": "application/json"
      },
      body: u ? JSON.stringify(u) : void 0,
      credentials: "include"
      // Ensures cookies are included for CORS requests
    };
    return he(o, p);
  }, { trigger: n, isMutating: r, error: i } = Xe(`/api/forms/${t}`, e);
  return { postForm: async (o) => {
    const u = await n({ url: `/api/forms/${t}`, ...o });
    if (!(u != null && u.success))
      throw new Error("The result is incorrect");
    return u;
  }, isMutating: r, error: i };
}, rn = (t) => {
  const { t: e } = Se(), [n, r] = vt(null), { postForm: i } = Qe(t), [s, o] = vt(!1);
  Jt(() => () => {
    r(null);
  }, []);
  const u = K(
    async (O) => {
      o(!0);
      let f = null;
      try {
        await i(O), f = {
          message: e("PageContent.Newsletter.SubmissionSuccess"),
          status: "success"
        };
      } catch {
        f = {
          message: e("PageContent.Newsletter.SubmissionError"),
          status: "error"
        };
      } finally {
        r(f), o(!1);
      }
      return (f == null ? void 0 : f.status) === "success";
    },
    [i, e]
  );
  return {
    alertData: n,
    submitNewsletter: u,
    closeAlert: () => {
      r(null);
    },
    showAlert: r,
    isLoading: s
  };
};
export {
  Qe as a,
  rn as u
};
